import request from '@/services/request'

export function fetchAll(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-recipe-mapping/list',
    method: 'get',
    params: data
  })
}

export function get(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-recipe-mapping/detail',
    method: 'get',
    params: data
  })
}

export function create(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-recipe-mapping/create',
    method: 'post',
    data: data
  })
}

export function update(data) {
  return request({
    url: process.env.BASE_URL_INVENTORY + '/master-material-recipe-mapping/update',
    method: 'put',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/master_material_recipe_mapping.js